import Grid from '../components/Grid.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import isEqual from 'lodash.isequal'

Vue.use(VueAxios, axios);

let listViewMixin = {
		components: {
			Grid
		},
		methods: {
			goToPage: function (event) {
				this.show = true

				let offset = null, limit = null, payload = {}

				if (event && event.offset > 0) {
					offset = event.offset + 1
				}

				if (event && event.limit > 0) {
					limit = event.limit
				}

				let config
				let url = '/3ds/api/' + this.restEntity

				payload.offset = offset
				payload.limit = limit
				payload.quickFind = false
				payload.search = false
				payload.searchCriteria = []
				if(this.$route.name === 'dictionaries') {
					payload.parentOrganization = this.parentOrganization
				}

				if (event.quickFind) {
					payload.quickFind = true
					payload.quickFindCriteria = event && event.searchCriteria && event.searchCriteria.length > 0 ? event.searchCriteria : ''
				} else {
					// url += '/search'
					payload.search = true
					if (event && event.searchCriteria && event.searchCriteria.length > 0) {
						let searchCriteria = []
						event.searchCriteria.forEach(eventSearchCriterion => {
							let searchCriterion = {
								"omit": false,
								"criteria": {}
							}
							for (const key in eventSearchCriterion) {
								if (eventSearchCriterion.hasOwnProperty(key)) {
									let value = eventSearchCriterion[key]
									if (key === 'omit' && value === 'true') {
										searchCriterion.omit = true
									} else if(key !== 'omit') {
										searchCriterion["criteria"][key] = value
									}
								}
							}
							searchCriteria.push(searchCriterion)
						})
						payload.searchCriteria = searchCriteria
					}
				}

				config = {
					method: 'get',
					headers: {
						'Authorization': 'Bearer ' + this.token
					},
					params: {
						query: payload
					}
				};

				if (event.sort) {
					payload.sort = event.sort
				}

				let that = this;
				let items = [];
				return Vue.axios(url, config)
					.then(value => {
						console.log('Retrieved ' + that.$route.name);
						console.log(JSON.stringify(value));
						let scriptResultObject = JSON.parse(value.data.scriptResult);
						if (value.data.data.length > 0) {
							that.rows = value.data.data;
							items = that.rows;
							that.maxRows = parseInt(scriptResultObject.foundCount);
							if (event) {
								that.page = event.page;
								if (event.limit > 0) {
									that.rowsPerPage = event.limit
								}
							}

							if (!event.quickFind) {
								let payload = {
									entity: that.restEntity,
									criteria: that.advancedSearchCriteria
								};

								that.setLastSearch(payload)
							}

						} else if(!event.quickFind) {
							that.show = false;
							that.pushError({
								type: 'WARNING',
								message: 'No records match the request'
							})
							that.maxRows = 0
						} else {
							that.maxRows = 0
						}
						return Promise.resolve(items.map((value) => {
							let fieldData = value.fieldData;
							fieldData['recordId'] = value.recordId;
							return fieldData
						}) || [])
					})
					.catch(reason => {
						console.log(JSON.stringify(reason));
						if (reason.response && reason.response.status === 401) {
							let msg = reason.response.data.message ? reason.response.data.message : reason.response.data.title;
							that.pushError({
								type: 'WARNING',
								message: msg
							});
							that.logOut().then(value => {
								that.$router.push('/', function () {
									console.log('Successfully logged out')
								})
							})
						} else if (reason.response && reason.response.data && reason.response.data.message || reason.response.data.title) {
							alert(reason.response.data.message ? reason.response.data.message : reason.response.data.title)
						}
						return Promise.reject(items.map((value) => {
							let fieldData = value.fieldData;
							fieldData['recordId'] = value.recordId;
							return fieldData
						}) || [])
					})
					.finally(() => {
						that.show = false
					})
			},
			exportToExcel: function () {
				let scriptName = '3DS_Excel_Export_On_Server';
				let fileName = 'export.xlsx';
				let quickFind = this.advancedSearchCriteria.length === 0 || isEqual(this.advancedSearchCriteria, this.emptySearchCriteria);
				let searchCriteria = quickFind ? this.searchCriteria : this.advancedSearchCriteria;
				let restEntity = this.restEntity;
				this.exportFile(searchCriteria, quickFind, restEntity, 'xlsx')
			}
			,
			saveAsPdf: function () {
				let scriptName = '3DS_PDF_Save_On_Server';
				let fileName = 'export.pdf';
				let quickFind = this.advancedSearchCriteria.length === 0 || isEqual(this.advancedSearchCriteria, this.emptySearchCriteria);
				let searchCriteria = quickFind ? this.searchCriteria : this.advancedSearchCriteria;
				let restEntity = this.restEntity;
				this.exportFile(searchCriteria, quickFind, restEntity)
			}
		},
		data() {
			return {
				rows: [],
				rowsPerPage: 50,
				maxRows: 50,
				page: 1,
				searchCriteria: '',
				advancedSearchCriteria: [],
				emptySearchCriteria: [{omit: "false"}]

			}
		}
	}
;

export default listViewMixin